
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { roomsData } from '../../mocks/rooms';

export default function Home() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language as 'ja' | 'en' | 'zh';

  const featuredRooms = roomsData.slice(0, 3);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/31c79c38e69c1816194d911769048496.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            東京タワービューの<br />
            プレミアム賃貸
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            外国人の方も安心。前金制度で審査なし・保証人不要<br />
            東京での新生活を完全サポート
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/rooms"
              className="bg-blue-600 hover:bg-blue-700 text-white py-4 px-8 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              東京タワービューの部屋を見る
            </a>
            <a
              href="/life-support"
              className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white border-2 border-white py-4 px-8 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              生活サポートについて
            </a>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">私たちのサービス</h2>
            <p className="text-xl text-gray-600">外国人の方の東京生活を総合的にサポート</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Rental Service */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">東京タワービュー賃貸</h3>
              <p className="text-gray-700 mb-6">
                東京タワーが見える特別なロケーションのマンションを中心に、外国人の方でも簡単に借りられる前金制度を採用。
                審査なし・保証人不要で、すぐにご入居いただけます。
              </p>
              <ul className="space-y-2 text-gray-700 mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>東京タワービューの厳選物件</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>前金2ヶ月以上で審査なし</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>保証人・保証会社不要</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>多言語対応サポート</span>
                </li>
              </ul>
              <a
                href="/rooms"
                className="inline-block bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                物件を見る
              </a>
            </div>

            {/* Life Support Service */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-6">
                <i className="ri-service-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">東京生活スタート支援</h3>
              <p className="text-gray-700 mb-6">
                東京での新生活に必要な手続きから日用品の調達まで、経験豊富なスタッフが丁寧にサポート。
                言葉の壁や文化の違いを気にせず、安心して東京生活をスタートできます。
              </p>
              <ul className="space-y-2 text-gray-700 mb-6">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>役所での各種手続き支援</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>生活必需品の買い物案内</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>家具・家電の代理調達・設置</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2"></i>
                  <span>銀行口座開設サポート</span>
                </li>
              </ul>
              <a
                href="/life-support"
                className="inline-block bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                サポート詳細
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Rooms */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">東京タワービューの厳選物件</h2>
            <p className="text-xl text-gray-600">特別なロケーションで、特別な東京生活を</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {roomsData.slice(0, 3).map((room) => (
              <div key={room.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="relative h-64">
                  <img
                    src={room.images[0]}
                    alt={room.title[currentLang]}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 right-4 bg-white px-3 py-1 rounded-full text-sm font-semibold text-blue-600">
                    {room.type[currentLang]}
                  </div>
                  <div className="absolute top-4 left-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
                    {room.size}
                  </div>
                  <div className="absolute bottom-4 left-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                    東京タワービュー
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{room.title[currentLang]}</h3>
                  <p className="text-gray-600 mb-4 flex items-center">
                    <i className="ri-map-pin-line mr-2"></i>
                    {room.location[currentLang]}
                  </p>
                  <p className="text-gray-700 mb-4 text-sm line-clamp-2">{room.description[currentLang]}</p>
                  
                  <div className="mb-4">
                    <div className="flex flex-wrap gap-2">
                      {room.amenities[currentLang].slice(0, 3).map((amenity, index) => (
                        <span key={index} className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs">
                          {amenity}
                        </span>
                      ))}
                      {room.amenities[currentLang].length > 3 && (
                        <span className="text-gray-500 text-xs">
                          +{room.amenities[currentLang].length - 3}
                        </span>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="flex items-center space-x-2">
                        <span className="text-2xl font-bold text-blue-600">{t('ask_price')}</span>
                      </div>
                    </div>
                    <Link
                      to={`/rooms/${room.id}`}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {t('view_details')}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link
              to="/rooms"
              className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-8 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              すべての物件を見る
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">なぜ私たちが選ばれるのか</h2>
            <p className="text-xl text-gray-600">外国人の方の東京生活を成功に導く理由</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-blue-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">簡単入居システム</h3>
              <p className="text-gray-600">
                前金2ヶ月以上で審査なし・保証人不要。複雑な手続きを排除し、すぐにご入居いただけます。
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-global-line text-green-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">多言語サポート</h3>
              <p className="text-gray-600">
                日本語・英語・中国語対応。言葉の壁を感じることなく、安心してサービスをご利用いただけます。
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-line text-purple-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">総合生活サポート</h3>
              <p className="text-gray-600">
                住まい探しから生活立ち上げまで、東京での新生活に必要なすべてをワンストップでサポート。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            東京での新生活を始めませんか？
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            東京タワービューの特別な住まいと、充実した生活サポートで<br />
            あなたの東京生活を成功に導きます
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white hover:bg-gray-100 text-blue-600 py-4 px-8 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              無料相談を申し込む
            </a>
            <a
              href="/rooms"
              className="bg-blue-700 hover:bg-blue-800 text-white py-4 px-8 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              物件を見る
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
